import React, {Component} from 'react';
import styled from 'styled-components'
import {ExternalLink} from "../RoutingLinks/RoutingLinks";

const FooterRow = styled.div.attrs({
    className: "row around-lg bottom-lg around-md bottom-md around-xs bottom-xs",
})`
  bottom:0; 
  width:100%; 
  height:300px; 
`;

const Column = styled.div.attrs({
    className: "",
})`
    font-size: 0.8em;
    > a {
        text-decoration: none;
    }
`;

class Footer extends Component {
    render() {
        return (
            <FooterRow>
                    <Column>
                        <ExternalLink to="https://envimate.com/#contact" displayText="Contact Us"/>
                    </Column>
                    <Column>
                        <ExternalLink to="https://www.envimate.com/PrivacyPolicy.html" displayText="Privacy Policy"/>
                    </Column>
                    <Column>
                        <ExternalLink to="https://envimate.com/impressum/" displayText="Impressum"/>
                    </Column>
            </FooterRow>
        )

    }
}

export default Footer;
